<template>
    <div class="pl-2 pr-2 pb-2" v-on:click="elegido">
        <md-card md-with-hover md-theme="inverso" >
            <md-ripple class="contenedor">
                <b-img v-bind="mainProps" :blank-color="datos.dt2" class="rad"/>
                <i class="flaticon2-checkmark icono" v-if="seleccionado"></i>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "boton-color",
        data:()=>({
            color:{id:null},
            mainProps: { blank: true, width: 75, height: 75, class: 'm1' },
            seleccionado:false,
        }),
        props:{
            datos:{
                type:Object,
                default:()=>({
                    id:null
                })
            },
            valor:{
                type:Object,
                default:()=>({
                    id:null
                })
            }
        },
        watch:{
          "valor.id":{
              handler(){
                  this.seleccionado=this.datos.id===this.valor.id;
              },
              deep: true
          }
        },
        methods:{
            elegido:function(){
                this.color=this.datos;
                this.$emit('input',this.datos);
            }
        },
        created() {
            this.seleccionado=this.datos.id===this.valor.id;
        }
    }
</script>

<style scoped>
    .contenedor{
        position: relative;
        display: inline-block;
        text-align: center;
        padding: 4px 4px 4px 4px;
        margin-bottom: -4px;
    }
    .icono{
        position: absolute;
        font-size: 20px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #000000;
        text-shadow: 0 0 5px #FFF, 0 0 10px #FFF, 0 0 15px #FFF, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #fff, 0 0 55px #fff, 0 0 75px #fff;
    }
    .rad{
        border-bottom: 3px;
    }
</style>
